import {
  ArrowRight,
  CalendarDays,
  Flame,
  Headphones,
  Newspaper,
  Search,
  ShoppingBag,
  Sparkles,
} from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useSearch } from '../../contexts/SearchContext';

const QUICK_ACCESS = [
  { label: 'Trending', query: 'trending', icon: Flame },
  { label: 'Latest Mixtapes', query: 'mixtapes', icon: Headphones },
  { label: 'Live Radio', query: 'radio', icon: Sparkles },
  { label: 'Events', query: 'events', icon: CalendarDays },
  { label: 'News', query: 'news', icon: Newspaper },
  { label: 'Shop', query: 'products', icon: ShoppingBag },
];

export default function ExploreSearchEntry() {
  const location = useLocation();
  const { openSearch } = useSearch();

  if (location.pathname !== '/explore') return null;

  return (
    <>
      <style>{`
        [data-testid="rastyleverse-gateway"] .grid.grid-cols-1 {
          margin-top: 13rem;
        }
        @media (min-width: 640px) {
          [data-testid="rastyleverse-gateway"] .grid.grid-cols-1 {
            margin-top: 14rem;
          }
        }
      `}</style>

      <div
        className="pointer-events-none absolute inset-x-0 top-[370px] z-30 px-5 sm:top-[410px] sm:px-8"
        data-testid="explore-search-entry"
      >
        <div className="pointer-events-auto mx-auto max-w-5xl">
          <button
            type="button"
            onClick={() => openSearch()}
            className="group relative flex min-h-[94px] w-full items-center gap-4 overflow-hidden border border-white/15 bg-black/90 px-5 py-5 text-left shadow-[0_24px_80px_rgba(0,0,0,0.55)] backdrop-blur-xl transition duration-300 hover:-translate-y-0.5 hover:border-rastyle-orange/70 hover:shadow-[0_28px_90px_rgba(255,116,0,0.12)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rastyle-orange sm:min-h-[108px] sm:gap-6 sm:px-8 sm:py-7"
            aria-label="Search everything in Rastyle"
          >
            <span className="pointer-events-none absolute inset-0 bg-gradient-to-r from-rastyle-orange/[0.08] via-transparent to-yellow-400/[0.04] opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

            <span className="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-rastyle-orange/25 bg-rastyle-orange/10 text-rastyle-orange shadow-[0_0_28px_rgba(255,116,0,0.12)] transition duration-300 group-hover:border-rastyle-orange/60 group-hover:bg-rastyle-orange group-hover:text-black group-hover:shadow-[0_0_36px_rgba(255,116,0,0.28)] sm:h-14 sm:w-14">
              <Search className="h-5 w-5 sm:h-6 sm:w-6" />
            </span>

            <span className="relative min-w-0 flex-1">
              <span className="block text-base font-semibold tracking-tight text-white sm:text-xl">
                Looking for something in particular?
              </span>
              <span className="mt-1.5 block truncate text-xs text-zinc-400 sm:text-[15px]">
                Events • Artists • Mixtapes • Radio • News • Shop • Creators
              </span>
            </span>

            <span className="relative hidden items-center gap-3 border-l border-white/10 pl-6 sm:flex">
              <span className="rounded border border-white/15 bg-white/[0.04] px-2.5 py-1.5 font-mono text-[10px] tracking-[0.14em] text-zinc-300">
                ⌘K
              </span>
              <span className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.16em] text-zinc-300 transition group-hover:text-rastyle-orange">
                Search
                <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </span>
            </span>
          </button>

          <div className="mt-3 flex gap-2 overflow-x-auto pb-1 sm:mt-4 sm:flex-wrap sm:justify-center sm:overflow-visible" aria-label="Quick search shortcuts">
            {QUICK_ACCESS.map(({ label, query, icon: Icon }) => (
              <button
                key={label}
                type="button"
                onClick={() => openSearch(query)}
                className="flex shrink-0 items-center gap-2 rounded-full border border-white/10 bg-black/75 px-3.5 py-2 text-xs text-zinc-400 backdrop-blur transition hover:border-rastyle-orange/50 hover:bg-rastyle-orange/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rastyle-orange"
              >
                <Icon className="h-3.5 w-3.5 text-rastyle-orange" />
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
